import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber3 = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm-.202 12.043a2.636 2.636 0 0 1-2.85-2.036l1.26-.483c.078.805.77 1.41 1.579 1.378A1.267 1.267 0 0 0 9.21 9.63c0-.777-.588-1.2-1.47-1.2h-.802V7.38h.743c.918 0 1.318-.482 1.318-1.236a1.086 1.086 0 0 0-1.19-1.072 1.384 1.384 0 0 0-1.388 1.284l-1.237-.495a2.582 2.582 0 0 1 2.673-1.965c1.554 0 2.543.812 2.543 2.13a1.727 1.727 0 0 1-1.495 1.825v.024a1.81 1.81 0 0 1 1.706 1.836c0 1.46-1.236 2.33-2.813 2.33z" />
    </g>
  );
};

export default withIcon(IconNumber3);
